import React from 'react'
import { FlagIcon } from 'src/components/framework/icons/flag'
import { Quote } from 'src/shared/quote.dto'
import { Security, StockReportData } from 'src/shared/security.dto'
import { getChangeClass } from 'src/shared/utils'

interface Props {
  security: Security
  quote: Quote
  isLoading: boolean
}

export const SecurityQuote: React.FC<Props> = ({
  security,
  quote,
  isLoading,
}) => {
  const changeClass = getChangeClass(parseFloat(quote.change))

  return (
    <>
      <div
        className={'stk-text-h3 stk-wrapper stk-space-out-b-2'}
        role="heading"
        aria-level={2}
        aria-label={`The current price of ${security.name} is ${quote?.price} that's ${quote?.changePercent} more than the previous close.`}
      >
        <span className={'stk-text-strong'} aria-hidden={true}>
          {quote.price}
        </span>
        {isLoading ? (
          <>
            <span className={'stk-text-loading'}>0.00</span>
            <span className={'stk-text-loading'}>0.00%</span>
          </>
        ) : (
          <>
            <span className={changeClass} aria-hidden={true}>
              {quote.change}
            </span>
            <span className={changeClass} aria-hidden={true}>
              {quote.changePercent}
            </span>
          </>
        )}
      </div>
      <div
        className={
          'stk-wrapper stk-wrapper--middle stk-text-small stk-space-out-b-2'
        }
      >
        <span style={{ height: '13px' }}>
          <FlagIcon country={security.countryCode} />
        </span>
        <span>
          Last Trade -&nbsp;
          {isLoading ? (
            <span className={'stk-text-loading'}>00:00</span>
          ) : (
            quote.lastTrade
          )}
        </span>
      </div>
    </>
  )
}
